<!--首页 技术分享-->
<template>
    <card :item="item" :type="type">
        <div class="cardbody color6" @click.stop="goDetails(item)">
            <div class="content">
                <el-image class="image" fit="cover" :src="item.cover"></el-image>
                <span class="tag">{{item.typeName}}</span>
                <div class="info">
                    <div>
                        <img src="@/assets/public/bofang.png" alt="">
                        {{item.commentCount}}次
                    </div>
                    <div>{{ item.duration }}</div>
                </div>
            </div>
            <div class="footer">
                <div class="title single_hide color3">{{item.title}}</div>
                <div>
                    <img :src="item.headImg" v-if="item.headImg" />
                    <img :src="require('@/assets/admin.png')" v-else />
                    <span class="color3">{{item.createUserName}}</span>
                </div>
            </div>
        </div>
    </card>
</template>

<script>

export default {
    name: "cardTechnologyShare",
    components: {
        card: () => import("@/components/card/card")
    },
    props: {
        item: Object,
        type: Number, // 1 工队 2 工程 3 工人 4 招工用工 5 工种报价 6劳务用工
    },
    methods: {
        //跳转详细
      goDetails(item) {
            window.open(`${process.env.VUE_APP_VIDEODETAIL}course/detail/${item.id}?curNo=${item.id}&typeName=${item.typeName}`)
        }
    }
}
</script>

<style lang="scss" scoped>
.cardbody {
    .content {
        position: relative;
        width: 273px;
        height: 233px;
        >.image {
            width: 100%;
            height: 233px;
        }
        .tag {
            position: absolute;
            top: 0;
            right: 0;
            border-bottom-left-radius: 8px;
            background: #0286df;
            color: #fefefe;
            padding: 4px 11px;
            font-size: 12px;
        }
        .info {
            position: absolute;
            left: 0;
            bottom: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            width: 100%;
            height: 36px;
            color: #fefefe;
            font-size: 14px;
            background: linear-gradient(0deg,rgba(0, 0, 0, 0.71) 28.999999999999996%,rgba(255, 255, 255, 0) 100%);
            img {
                width: 14px;
                height: 16px;
                margin-right: 5px;
            }
        }
    }
    .footer {
        padding: 12px 20px;
        width: 273px;
        height: 85px;
        .title {
            margin-bottom: 13px;
            font-size: 16px;
            font-weight: normal;
        }
       >div {
           display: flex;
           justify-content: space-between;
           align-items: center;
       }
        img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
        }


    }
}
.single_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
div {
    box-sizing: border-box;
}
.color6 {
    color: #666666;
}
.color3 {
    color: #333333;
}
</style>
